import * as MwVisualizations from './index';
import MwChartDonut from './mw-chart-donut/module';
import MwChartGroupedColumn from './mw-chart-grouped-column/module';
import MwChartHeatmap from './mw-chart-heatmap/module';
import MwChartNSeriesLineModule from './mw-chart-n-series-line/module';
import MwChartOneSeriesBar from './mw-chart-one-series-bar/module';
import MwChartOneSeriesColumn from './mw-chart-one-series-column/module';
import MwChartStackedColumn from './mw-chart-stacked-column/module';
import MwChartStackedPercentageColumn from './mw-chart-stacked-percentage-column/module';
import MwChartTwoYAxisLineModule from './mw-chart-two-yaxis-line/module';
import MwChartWordCloudModule from './mw-chart-word-cloud/module';
import MwNumber from './mw-number/module';
import MwNumberDelta from './mw-number-delta/module';

angular.module(MwVisualizations.MW_VISUALIZATIONS_BASE_MODULE_NAME, [
    MwChartDonut.name,
    MwChartGroupedColumn.name,
    MwChartHeatmap.name,
    MwChartNSeriesLineModule.name,
    MwChartOneSeriesBar.name,
    MwChartOneSeriesColumn.name,
    MwChartStackedColumn.name,
    MwChartStackedPercentageColumn.name,
    MwChartTwoYAxisLineModule.name,
    MwChartWordCloudModule.name,
    MwNumber.name,
    MwNumberDelta.name
]);

module.exports = MwVisualizations;
